import { getAuth, signInWithCustomToken } from 'firebase/auth';

export async function loginWithOnboardingHash(hash) {
  const response = await fetch('/.netlify/functions/authenticate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hash }),
  });

  if (!response.ok) {
    const text = await response.text();
    let message = `Authentication failed: ${text}`;
    try {
      const parsed = JSON.parse(text);
      if (parsed && parsed.message) message = parsed.message;
    } catch (_) {}
    throw new Error(message);
  }

  const data = await response.json();
  await signInWithCustomToken(getAuth(), data.token);
  return data;
}
